export default __webpack_public_path__ + "static/media/billreynolds_cast.0a5f7ca6.jpg";